import { datadogLogs } from '@datadog/browser-logs';
import { Fingerprint } from 'app/pages/frames/helpers/fingerprint';
import { InitTagManager } from 'app/util/analytics/analytics';
import { datadogRum } from '@datadog/browser-rum';
import ReactGA from 'react-ga4';

export const initializeDatadogRum = () => {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DD_RUM_APP_ID,
    clientToken: import.meta.env.VITE_DD_RUM_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: import.meta.env.VITE_DD_SERVICE,
    version: import.meta.env.PACKAGE_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
};

export const initializeDatadogLogs = () => {
  datadogLogs.init({
    clientToken: import.meta.env.VITE_DD_LOGS_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: import.meta.env.VITE_DD_SERVICE,
    forwardConsoleLogs: ['error', 'info'],
    sessionSampleRate: 100,
    forwardErrorsToLogs: false,
  });
};

export const initializeFingerprint = () => {
  Fingerprint.init();
};

export const initializeGoogleAnalytics = () => {
  ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_ID, {
    gaOptions: {
      cookieDomain: 'auto',
    },
  });
  InitTagManager(window, import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID);
};
